<template>
    <div class="content-box">
        <div class="element-wrapper">
            <div class="element-box">
                <h5 class="form-header">Auditoría de Activos Fijos</h5>
                <div class="controls-above-table">
                    <div class="row">
                        <div class="col-sm-1">
                            <label class="d-block" style="color: gray;"><b>Ahora viendo: </b></label>
                        </div>
                        <div class="col-sm-3">
                            <TiendaSelectComponent _class="form-control form-control-sm rounded bright" titulo="hide"
                                :desblock="true" placeholder="TODAS LAS TIENDAS" :current="filter"
                                @change="filterData()" @onChange="filterData()" />
                        </div>
                    </div>
                    <br>
                    <div>
                        <button class="btn btn-block btn-dark" data-toggle="modal" data-target="#exampleModalCenter"><i
                                class="fas fa-plus"></i>&nbsp;Crear Auditoría</button>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">Nueva Auditoría</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div>
                                <label>Usuario:</label>
                                <input type="text" class="form-control form-control-sm" style="border-radius: 50px;"
                                    :value="current.user" disabled>
                            </div>
                            <div>
                                <label>¿Para qué Tienda?</label>
                                <TiendaSelectComponent _class="form-control form-control-sm rounded bright"
                                    titulo="hide" :current="current" @change="(value) => current.tienda = value" />
                            </div>
                            <div>
                                <label>Categoría <span style="color: green;">*</span></label>
                                <br>
                                <GrupoActivoComponent _class="form-control form-control-sm rounded bright" titulo="hide"
                                    :desblock="true" :disabled="current.estado == '9'" :current="current" />
                            </div>
                            <label style="color: green;">* Sin selección = Todas las categorías</label>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-dismiss="modal"
                                @click="cancelar()">Cancelar <i class="fas fa-times"></i></button>
                            <button type="button" class="btn btn-dark" @click="change()"><i
                                    class="fas fa-undo"></i></button>
                            <button type="button" class="btn btn-primary" @click="crearAuditoria()">Crear <i
                                    class="fas fa-check"></i></button>
                        </div>
                        <div style="text-align: center;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="element-box">
                <div class="card-container">
                    <div class="card" v-for="auditoria in data" :key="auditoria.id" :class="{
                        'card-abierto': auditoria.estado === 'A',
                        'card-cerrado': auditoria.estado === 'B',
                        'card-anulado': auditoria.estado === '9'
                    }" @click="verDetalles(auditoria.id)">
                        <div class="card-body">
                            <h5 class="card-title" style="text-align: center; font-size: 22px;">
                                #{{ auditoria.numero }}
                            </h5>
                            <h5 style="font-size: 19px; text-align: center;">
                                {{ auditoria.tienda_obj.nombre }}
                            </h5>
                            <hr>
                            <p class="card-text">Usuario: <b>{{ auditoria.usuario_obj ? auditoria.usuario_obj.username :
                                '-' }}</b></p>
                            <p class="card-text">Categoría: <b>{{ auditoria.grupo_obj ? auditoria.grupo_obj.nombre :
                                'Todas' }}</b></p>
                            <p class="card-text">Inicio: <b>{{ formatDate(auditoria.fecha_creacion) }}</b></p>
                            <p class="card-text">Fin: <b>{{ formatDate(auditoria.fecha_finalizacion) }}</b></p>
                            <br>
                            <p class="card-text" style="text-align: center;">
                                <span class="badge" :class="{
                                    'badge badge-pill badge-success': auditoria.estado === 'A',
                                    'badge badge-pill badge-dark': auditoria.estado === 'B',
                                    'badge badge-pill badge-danger': auditoria.estado === '9'
                                }">
                                    {{ getEstadoLabel(auditoria.estado) }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="footer">
                <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import PaginationComponent from "@/components/utils/PaginationComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import GrupoActivoComponent from "@/components/commons/GrupoActivoComponent";

export default {
    components: {
        TiendaSelectComponent,
        PaginationComponent,
        GrupoActivoComponent,
    },
    computed: {
        localUserProfile() {
            return { ...this.user_profile };
        }
    },
    data() {
        return {
            current: {
                tienda: "",
                user: localStorage.getItem("username"),
                user_id: localStorage.getItem("id_usuario"),
                grupo: null,
            },
            filter: { tienda: "", grupo: null },
            data: [],
            currentPage: 1,
            selectedCategoria: null,
            categorias: [],
        }
    },
    mounted() {
        let self = this
        self.refreshData();
    },
    methods: {
        updateUserProfile() {
            this.$emit('update:user_profile', this.localUserProfile);
        },
        refreshData(params) {
            let self = this;
            DynamicService.fetch("af", "auditoria-af", params).then((res) => {
                self.data = res.data.results;
            });
        },
        filterData() {
            this.refreshData({
                page: 1,
                tienda: this.filter.tienda,
                "filter[search]": this.searchtext,
            });
        },
        onPageChange(page) {
            this.currentPage = page;
            this.refreshData({
                page: this.currentPage,
                tienda: this.filter.tienda,
            });
        },
        crearAuditoria() {
            let self = this;
            if (!self.current.tienda) {
                this.$toast.warning(" Debe seleccionar una tienda para continuar.", " No se pudo crear el registro.", {
                    position: 'topRight'
                });
                return;
            }
            var parametros = {
                tienda: self.current.tienda,
                usuario: self.current.user_id,
                grupo: self.current.grupo
            };
            DynamicService.save("af", "auditoria-af", parametros)

                .then((response) => {
                    Notifications.alert.success(
                        "Auditoría Creada",
                        "Se añadió un nuevo registro"
                    );
                    self.$router.push({
                        name: "af-auditoria-af-editar",
                        params: { id: response.data.id },
                    });
                    $("#exampleModalCenter").modal("hide");
                    self.refreshData();
                })
                .catch((errors) => {
                    Notifications.alert.error("Error: ", errors.response.data.detail);
                });
        },
        formatDate(dateString) {
            if (!dateString) {
                return 'En Proceso';
            }
            return moment(dateString).format('DD-MM-YYYY HH:mm') + " Hrs.";
        },
        getEstadoLabel(estado) {
            switch (estado) {
                case 'A':
                    return 'Abierta';
                case 'B':
                    return 'Finalizada';
                case '9':
                    return 'Anulada';
                default:
                    return 'Desconocido';
            }
        },
        cancelar() {
            let self = this;
            self.refreshData();
            self.change();
            $("#exampleModalCenter").modal("hide");
        },
        change() {
            let self = this;
            self.current.tienda = "";
            self.current.grupo = null;
        },
        verDetalles(auditoriaId) {
            this.$router.push({ name: 'af-auditoria-af-editar', params: { id: auditoriaId } });
        },
    },
}
</script>
<style scoped>
.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: -10px;
}

.card {
    border: 1px solid #ddd;
    border-radius: 12px;
    margin: 10px;
    padding: 10px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s, background-color 0.3s;
    flex: 1 1 calc(20% - 20px);
}

.card:hover {
    transform: translateY(-5px);
    background-color: #f9f9f9;
}

.card-title {
    font-size: 1.5rem;
    margin-bottom: 5px;
}

.card-text {
    margin: 5px 0;
    font-size: 0.9rem;
}


@media (max-width: 768px) {
    .card {
        flex: 1 1 100%;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .card {
        flex: 1 1 45%;
    }
}

@media (min-width: 1025px) {
    .card {
        flex: 1 1 calc(20% - 20px);
    }
}

.card-abierto {
    background-color: #e1fce1;
    border-left: 5px solid #a5d8a5;
}

.card-cerrado {
    background-color: #ffedcc;
    border-left: 5px solid #e0c99e;
}

.card-anulado {
    background-color: #fce1e1;
    border-left: 5px solid #f5c6cb;
}
</style>